'use client'

import Script from 'next/script'

export function AnalyticsScripts() {
  return (
    <>
      <Script async src="https://www.googletagmanager.com/gtag/js?id=G-J0DJRH5WCL" strategy="afterInteractive" />
      <Script async id="google-analytics" strategy="afterInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'G-J0DJRH5WCL');
        `}
      </Script>
      <Script async src="https://scripts.simpleanalyticscdn.com/latest.js" strategy="afterInteractive" />

      {/* Hotjar Tracking Code for OpSynk */}
      <Script async id="hotjar" strategy="afterInteractive">
        {`
          (function(h,o,t,j,a,r){
              h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
              h._hjSettings={hjid:6543408,hjsv:6};
              a=o.getElementsByTagName('head')[0];
              r=o.createElement('script');r.async=1;
              r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
              a.appendChild(r);
          })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
        `}
      </Script>
    </>
  )
}
